import React from "react";
import CmsBuybox from "../cms-buy-box";

/**
 * Componente que permite crear un array de buybox
 */
function CmsBuyboxList(props) {
  const {
    cmsHandler,
    alias,
    blockName,
    CmsEditableGroupIcons,
  } = props;
  const buyBoxList = props["cms-ml-buy-box-list"];

  return (
    <div className="buybox-gap hiddenPrice">
      <div className="buybox-content">
        {buyBoxList &&
          Array.isArray(buyBoxList) &&
          buyBoxList.length > 0 &&
          buyBoxList.map((buyboxItem, index) => {
            return (
              <CmsBuybox
                {...buyboxItem}
                key={`buybox-item-${index}`}
                showSeparator={index !== buyBoxList.length - 1}
                blockName={blockName}
                alias={alias}
                index={index}
                cmsHandler={cmsHandler}
                frontalListToDelete={buyBoxList}
                CmsEditableGroupIcons={CmsEditableGroupIcons}
              />
            );
          })}
      </div>
      <style jsx>{`.buybox-gap {
  position: relative;
  .edit-legal-gap {
    position: relative;
    display: flex;
    align-items: baseline;
    :global(.element-editable) {
      position: relative;
    }
  }
  .skeleton {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
  }
  .buybox-content {
    :global(hr.separator) {
      color: rgb(221, 221, 221);
    }
  }
}
`}</style>
    </div>
  );
}

export default CmsBuyboxList;
